import { RouteUrl } from '@core/enums/routing.enums'

export const STORAGE_LAST_URL_KEY = 'mm__last-url'

export const COMMON_PERMISSIONS = [RouteUrl.Login]

// IMPORTANT routes should follow order following angular strategy (specific routes first, variable routes last)
export const COMMON_AUTH_PERMISSIONS = [
  RouteUrl.Main,
  RouteUrl.MainSub,
  RouteUrl.Profile,
  RouteUrl.AuthLogout,
  RouteUrl.HomeMetricFinder,
  RouteUrl.More,
  RouteUrl.TeamSelect,
  RouteUrl.Notifications,
  RouteUrl.NotificationDetails,
  RouteUrl.Metrics,
  RouteUrl.MCSuite,
  RouteUrl.Info,
  RouteUrl.Legal,
  RouteUrl.MatchStandings,
  RouteUrl.MatchCalendar,
  RouteUrl.MatchDetail,
  RouteUrl.MatchDetailMetricFinder,
  RouteUrl.MatchPlayerDetail,
  RouteUrl.MatchPlayerDetailMetricFinder,
  RouteUrl.MetricDetail,
  RouteUrl.TeamCompareDetail,
  RouteUrl.TeamCompareDetailMetricFinder,
  RouteUrl.PlayerDetail,
  RouteUrl.PlayerDetailMetricFinder,
  RouteUrl.PlayerCompareDetail,
  RouteUrl.MatchPlayerCompareDetail,
  RouteUrl.MatchPlayerCompareDetailMetricFinder,
  RouteUrl.PlayerCompareDetailMetricFinder,
  RouteUrl.NetworkTimeout
]
